/*
 * ##############################################################################
 * Module Name                   : Approvel.jsx
 * Purpose of the Module         : 
 * Description of the Module     : 
 * Original Author               :  T A C Priyashad
 * Date                          : Tuesday, August 9th 2022, 10:59:07 pm
 * Copyright (c) 2022 myPOS Software Solution (pvt Ltd.)
 * ##############################################################################
 */

import React, { useEffect, useState } from "react";
import { Row, Col, Button, Label } from "reactstrap"
import {
    GetPermissionList,
    SendApprovalData
} from "../Transaction/TransactionController"

const Approvel = ({
    txn,
    DocNo,
    DocDate,
    LocCode,
    LocName,
    User,
    NetValue,
    ApprovelDetails,
    getData,
    Transaction,
    SetLoadingAlert,
    SetLoadingAlerttitle
}) => {

    return (
        <React.Fragment>
            <Row>
                <h5>Approvals</h5>
            </Row>
            <hr />
            <Row>
                <table>
                    <tbody>
                        <tr>
                            <td style={{ width: "200px" }}>Transaction Type</td>
                            <td>{`${txn.strTX_TYPE} - ${txn.strTX_DESC}`}</td>
                            <td style={{ width: "200px" }}>Transaction No</td>
                            <td>{DocNo}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "200px" }}>Location</td>
                            {/* <td>{`${LocCode} - ${LocName}`}</td> */}
                            <td>{`${LocCode}`}</td>
                            <td style={{ width: "200px" }}>User</td>
                            <td>{User}</td>
                        </tr>
                        <tr>
                            <td style={{ width: "200px" }}>Posted Date</td>
                            <td>{DocDate}</td>
                            <td style={{ width: "200px" }}>Transaction Value</td>
                            <td>{NetValue.toLocaleString(undefined, {
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2,
                            })}</td>
                        </tr>
                    </tbody>
                </table>
            </Row>
            <Row className="mt-3">
                <table>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Approval request</th>
                            <th>Status</th>
                            <th>Checked values</th>
                            <th>Priority</th>
                            <th>Approve Status</th>
                            <th>Approved by</th>
                            <th>Remarks</th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {(ApprovelDetails || { id: 1 }).map((data, key) => (
                            <ApprovelDetailRow
                                Key={key}
                                data={data}
                                DocNo={DocNo}
                                getData={getData}
                                Transaction={Transaction}
                                ApprovelDetails={ApprovelDetails}
                                SetLoadingAlert={SetLoadingAlert}
                                SetLoadingAlerttitle={SetLoadingAlerttitle}
                            />
                        ))}
                    </tbody>
                </table>
            </Row>
        </React.Fragment>
    );
}
export default Approvel;

const ApprovelDetailRow = ({ data, Key, DocNo, getData, Transaction, ApprovelDetails, SetLoadingAlert, SetLoadingAlerttitle }) => {
    const [BtnShow, setBtnShow] = useState(false);
    const [remarks, setRemarks] = useState("");

    useEffect(() => {
        CheckPermission();
    }, [ApprovelDetails, data.strRA_REMARKS])


    useEffect(() => { setRemarks("") }, [data])

    const CheckPermission = async () => {
        let permission = await GetPermissionList(data.strRA_TXN_PERMISSION);
        if (permission && Object.keys(permission).length > 0 && permission.strMenuAccessRight && data.shrtRA_APPROVED == 0) {
            setBtnShow(true);  // Show buttons if condition is met
        } else {
            setBtnShow(false);  // Hide buttons otherwise
        }
    };

    const SendApprovalDataToEndpoint = async (status) => {
        var obj = JSON.parse(localStorage.getItem("authUser"))
        let LogUserType = obj[2]
        let LocationCode = obj[3]
        let CompanyCode = obj[5]
        let body = {
            "recordID": data.id,
            "strUserID": LogUserType,
            "strLocCode": LocationCode,
            "strDocNo": DocNo,
            "strMenuCode": data.strRA_TXN_PERMISSION,
            "intApproval": parseInt(status),
            "strRemarks": remarks,
            "strComCode": CompanyCode,
            "strType": Transaction
        }

        try {
            SetLoadingAlert(true)
            SetLoadingAlerttitle("Sending Approval Data")
            const dataSet = await SendApprovalData(body);
            dataSet == 1 ? getData(DocNo) : SetLoadingAlert(false)
        } catch (e) {
            console.log(e)
            SetLoadingAlert(false)
        }

    }

    return (
        <tr>
            <td>{Key + 1}</td>
            <td>{data.strRA_TXN_PERMISSION}</td>
            <td>{data.isCurrent ? "Active Approval" : "Previous Approval"}</td>
            <td>{data.strRA_REQUEST}</td>
            <td>{data.intRA_PRIORITY}</td>
            <td>{data.shrtRA_APPROVED == 0 ? "Pending" : data.shrtRA_APPROVED == 1 ? "Approved" : data.shrtRA_APPROVED == 2 ? "Rejected" : data.shrtRA_APPROVED == 3 ? "Review" : ""}</td>
            <td>{data.strRA_APPRIVED_BY}</td>
            <td>{BtnShow ? (<input type="text" value={remarks} onChange={(e) => { setRemarks(e.target.value) }} />) : data.strRA_REMARKS}</td>
            <td>
                {BtnShow ? (<Button
                    outline
                    disabled={false}
                    color="success"
                    onClick={e => {
                        SendApprovalDataToEndpoint(1)
                    }}
                    size="sm"
                >
                    Approve <i className="mdi mdi-check-bold" style={{ fontSize: "12px" }}></i>
                </Button>) : null}
            </td>
            <td>
                {BtnShow ? (<Button
                    outline
                    disabled={false}
                    color="danger"
                    onClick={e => {
                        SendApprovalDataToEndpoint(2)
                    }}
                    size="sm"
                >
                    Disapprove <i className="mdi mdi-close-thick" style={{ fontSize: "12px" }}></i>
                </Button>) : null}
            </td>
            <td>
                {BtnShow ? (<Button
                    outline
                    disabled={false}
                    color="primary"
                    onClick={e => {
                        SendApprovalDataToEndpoint(3)
                    }}
                    size="sm"
                >
                    Review <i className="mdi mdi-file-document-edit" style={{ fontSize: "12px" }}></i>
                </Button>) : null}
            </td>
        </tr>
    );
}

// 0 prending
// 1 approved
// 2 rejected
// 3 review


//senarios that can happen
//1. all the approvals are 1 then the transaction is approved and can not be edited
//2. all the approvals are 2 then the transaction is rejected and can not be edited
//3. all the approvals are 0 then the transaction is pending approval and can not be edited
//4. all the approvals are 3 then the transaction is under review and can be edited
//5. if there is any 1 and 0 then the transaction is pending approval and can not be edited
//6. if there is any 2 and 0 then the transaction is rejected and can not be edited
//7. if there is any 3 and 0 then the transaction is under review and can be edited
//8. if there is any 1 and 2 then the transaction is rejected and can not be edited
//9. if there is any 1 and 3 then the transaction is approved and can not be edited
//10. if there is any 2 and 3 then the transaction is rejected and can not be edited
//11. if there is any 1 and 2 and 3 then the transaction is rejected and can not be edited
//12. if there is any 1 and 2 and 0 then the transaction is rejected and can not be edited
//13. if there is any 1 and 3 and 0 then the transaction is approved and can not be edited
//14. if there is any 2 and 3 and 0 then the transaction is rejected and can not be edited
//15. if there is any 1 and 2 and 3 and 0 then the transaction is rejected and can not be edited
